export default {"src":"/_next/static/media/money.d2b1e8cb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};